import { Service } from '../../helpers/authservice/camera-violation.service';
import router from '../../router/index'
import Swal from 'sweetalert2';

export const state = {
    violationTypes: [],
    pagination: {
        per_page: '',
        total: '',
        page: ''
    },
}

export const mutations = {
    FETCH_VIOLATION_TYPES: (state, payload) => {
        state.violationTypes = payload;
    },
    FETCH_PAGINATION: (state, payload) => {
        state.pagination = payload;
    }
}

export const actions = {
    getViolationTypes: ({ commit, dispatch }, pagination) => {
        dispatch('globals/loading', null, { root: true })

        Service.getAll(pagination)
        .then(({ data, meta }) => {
            commit('FETCH_VIOLATION_TYPES', data);
            commit('FETCH_PAGINATION', {
                page: meta.current_page,
                total: meta.total,
                per_page: meta.per_page
            });
            dispatch('globals/loaded', null, { root: true })
        })
        .catch((error) => {
            const { message } = error.response.data;
            dispatch('notification/error', message, { root: true });
            dispatch('globals/loaded', null, { root: true })
        })
    },
    createViolationType: ({ dispatch }, body) => {
        dispatch('globals/loading', null, { root: true })

        const newViolationType = { 
            ...body,
        }

        Service.create(newViolationType)
        .then(() => {
            dispatch('notification/clear', null, { root: true });
            router.push('/settings/camera/violation/list');
            Swal.fire("Success", `You have created a new camera captured violation ${newViolationType.violation}` , "success");
            dispatch('globals/loaded', null, { root: true })
        })
        .catch((error) => {
            const { errors } = error.response.data;
            window.scrollTo(0, 0);
            dispatch('notification/errors', errors, { root: true });
            dispatch('globals/loaded', null, { root: true })
         })
    },
    updateViolationType: ({ dispatch }, body) => {
        dispatch('globals/loading', null, { root: true })

        const existingViolationType = { 
            ...body, 
        }
        console.log(existingViolationType);

        Service.update(existingViolationType)
        .then(() => {
            window.scrollTo(0, 0);
            dispatch('notification/success', 'Camera Captured Violation updated successfully', { root: true });
            dispatch('globals/loaded', null, { root: true })
        })
        .catch((error) => {
           const { errors } = error.response.data;
           window.scrollTo(0, 0);
           dispatch('notification/errors', errors, { root: true });
           dispatch('globals/loaded', null, { root: true })
        })
    },
    deleteViolationType: ({ state, dispatch }, id) => {
        dispatch('globals/loading', null, { root: true })

        Service.destroy(id)
        .then(() => {
            dispatch('notification/clear', null, { root: true });
            router.push('/settings/camera/violation/list');
            dispatch('globals/loaded', null, { root: true });
            dispatch('getViolationTypes', state.pagination);
           
        })
        .catch((error) => {
            const { errors } = error.response.data;
            window.scrollTo(0, 0);
            dispatch('notification/errors', errors, { root: true });
            dispatch('globals/loaded', null, { root: true });
         })
    }
}